// Johku Max icon names (johku-max core ICONS) as the Font Awesome icons POS uses elsewhere
export const MAX_POS_ICONS = {
  add: 'fa-plus',
  alert: 'fa-exclamation-triangle',
  archive: 'fa-archive',
  'arrow-left': 'fa-arrow-left',
  'arrow-right': 'fa-arrow-right',
  bell: 'fa-bell',
  bus: 'fa-bus',
  calendar: 'fa-calendar',
  check: 'fa-check',
  'chevron-down': 'fa-chevron-down',
  'chevron-left': 'fa-chevron-left',
  'chevron-right': 'fa-chevron-right',
  'chevron-up': 'fa-chevron-up',
  clock: 'fa-clock',
  close: 'fa-close',
  copy: 'fa-copy',
  delete: 'fa-trash',
  download: 'fa-download',
  edit: 'fa-pencil',
  euro: 'fa-euro',
  filter: 'fa-filter',
  hide: 'fa-eye-slash',
  home: 'fa-home',
  info: 'fa-info-circle',
  key: 'fa-key',
  list: 'fa-list',
  location: 'fa-map-marker',
  lock: 'fa-lock',
  mail: 'fa-envelope',
  minus: 'fa-minus',
  phone: 'fa-phone',
  print: 'fa-print',
  refresh: 'fa-rotate',
  save: 'fa-save',
  search: 'fa-search',
  settings: 'fa-sliders',
  show: 'fa-eye',
  star: 'fa-star',
  tag: 'fa-tag',
  undo: 'fa-undo',
  user: 'fa-user',
  users: 'fa-users'
}
